import React from "react";
import Link from "next/link";
import styles from "./country_box.module.scss";

export const CountyBox = (props) => {
  return (
    <Link legacyBehavior href={`/${props?.countrySlug}/university`}>
      <a>
        <div className={styles.country}>
          <div className={styles.country_image}>
            <img src={props?.image} alt={props?.title || "test"} />
            <span className={styles.country_overly}>&nbsp;</span>
          </div>
          <div className={styles.country_caption}>
            <div
              className={styles.country_name}
              style={{ width: props?.size === "large" ? "50%" : "100%" }}
            >
              {props?.title || "country name"}
            </div>
            <div
              className={styles.country_info}
              style={{ width: props?.size === "large" ? "50%" : "100%" }}
            >
              <p className={styles.country_university}>
                {props?.university || 0}{" "}
                {props?.university > 1 ? "Universities" : "University"}
              </p>
              <p className={styles.country_courses}>
                {props?.courses || 0}{" "}
                {props?.courses > 1 ? "Courses" : "Course"}
              </p>
            </div>
          </div>
        </div>
      </a>
    </Link>
  );
};
export default CountyBox;
